import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../hoc/AuthContext";

import { HeaderWebsiteConfig, useIntegratorTheme } from "../hooks/apiHooks/HeaderHook";

import {
  canAccessPublicRewardDetail, canAccessPublicRewardListing, getSubdomainInfo, isHomeLandingPage,
  isRewardListingLandingPage, newTheme
} from "../Utils/CommonFunctions";
import { HOMEPAGE } from "../Utils/Constant";

import { AUTH } from "./RoutesContant";

const PrivateRoute = () => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();
  const { headerConfigData, isConfigLoading } = HeaderWebsiteConfig();
  const { isSubdomain } = getSubdomainInfo();
  const { integratorTheme, isIntegratorThemeLoading } = useIntegratorTheme(isSubdomain, newTheme);

  const websiteInfo = headerConfigData?.WebsiteConfig || {};
  const websiteHeaderInfo = headerConfigData?.Header || {};

  const homePageType = websiteInfo.landing_page || HOMEPAGE;
  const authPageType = websiteHeaderInfo.auth_page_type;
  const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
  const isRewardListingPath = normalizedPath === "/rewards";
  const isRewardDetailPath = /^\/rewards\/(discount|cashback|giftcard|subscription)\/[^/]+\/[^/]+$/.test(normalizedPath);
  const publicLevel = integratorTheme?.public_level;
  const canShowPublicRewardListing = canAccessPublicRewardListing(publicLevel);
  const canShowPublicRewardDetail = canAccessPublicRewardDetail(publicLevel);
  const isRewardListingLanding = isRewardListingLandingPage(homePageType);
  const isPublicRewardPreviewPath = isRewardListingPath || isRewardDetailPath;
  const canAccessPublicRewardPreview = !isAuthenticated && (
    (isRewardListingPath && (canShowPublicRewardListing || isRewardListingLanding))
    || (isRewardDetailPath && canShowPublicRewardDetail)
  );

  if (isLoading || isConfigLoading || !headerConfigData || (isPublicRewardPreviewPath && isIntegratorThemeLoading)) return null;

  if (authPageType === "full_page" && isRewardListingPath && isRewardListingLanding && !isAuthenticated) {
    return <Navigate to={`/${AUTH}`} state={{ from: location }} replace />;
  }

  if (canAccessPublicRewardPreview) {
    return <Outlet />;
  }

  if (authPageType === "full_page" && !isHomeLandingPage(homePageType) && !isAuthenticated) {
    return <Navigate to={`/${AUTH}`} state={{ from: location }} replace />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" state={{ from: location }} replace />;
};

export default PrivateRoute;
